import React, { useState } from 'react';
import { Form, Input, InputNumber, Select, DatePicker, Button, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useHealthStore } from '@/stores/useHealthStore';

interface BSFormProps {
  onSuccess?: () => void;
}

const BSForm: React.FC<BSFormProps> = ({ onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const addBloodSugar = useHealthStore(state => state.addBloodSugar);

  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      await addBloodSugar({
        date: values.date.format('YYYY-MM-DD'),
        value: values.value,
        type: values.type,
        notes: values.notes
      });
      message.success('血糖记录已保存');
      form.resetFields();
      onSuccess?.();
    } catch (error) {
      message.error('保存失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{
        date: dayjs(),
        type: 'fasting'
      }}
    >
      <Form.Item
        label="测量日期"
        name="date"
        rules={[{ required: true, message: '请选择日期' }]}
      >
        <DatePicker style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item
        label="测量类型"
        name="type"
        rules={[{ required: true }]}
      >
        <Select
          options={[
            { label: '空腹', value: 'fasting' },
            { label: '餐后1小时', value: 'post_meal_1h' },
            { label: '餐后2小时', value: 'post_meal_2h' },
            { label: '随机', value: 'random' }
          ]}
        />
      </Form.Item>

      <Form.Item
        label="血糖值"
        name="value"
        rules={[
          { required: true, message: '请输入血糖值' },
          { type: 'number', min: 1, max: 30, message: '范围 1-30' }
        ]}
      >
        <InputNumber
          style={{ width: '100%' }}
          placeholder="例如：5.6"
          step={0.1}
          suffix="mmol/L"
        />
      </Form.Item>

      <Form.Item label="备注" name="notes">
        <Input.TextArea rows={2} placeholder="可选：备注信息" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} icon={<SaveOutlined />} block>
          保存血糖记录
        </Button>
      </Form.Item>
    </Form>
  );
};

export default BSForm;
